export const CURRENCY = "$";
export var recordsLimit = 10;
export var recordsLimit50 = 50;

export const fileTypesAllowed = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "video/mp4",
  "video/mpeg",
  "video/quicktime",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
export const videoFileTypes = ["mp4", "mpeg", "quicktime"];
export const falsyArray = [
  null,
  undefined,
  "",
  0,
  false,
  NaN,
  "null",
  "undefined",
  "false",
  "0",
  "NaN",
];

export const STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export const roles = {
  SCHOOL_ADMIN: "school-admin",
  STUDENT: "student",
  SPECIALIST: "specialist",
};

// Pages that only exist because a school pays. Internal (client-owned) schools
// never buy a bundle or credits, so these are hidden from their sidebar and
// blocked in ProtectedRoute — the latter matters because hiding a nav item
// does nothing about someone typing the URL.
export const billingRoutes = ["/assessment-packages", "/my-package-credits"];

export const QUESTION_TYPE = {
  MCQ: "mcq",
  GAP_FILL: "gapFill",
  MATCHING: "matching",
  SEQUENCE: "sequence",
  SPEAKING: "speaking",
  WRITING: "writing",
  COMPARATIVE: "comparative",
  UNORDERED_TABLE: "unorderedTable",
};
export const QUESTION_SET_DOMAIN = {
  READING: "reading",
  WRITING: "writing",
  LISTENING: "listening",
  SPEAKING: "speaking",
  VOCABULARY: "vocabulary",
};
export const ASSESSMENT_CYCLE_TASK = {
  SUMMATIVE: "summative",
  LISTENING_SPEAKING: "listening-speaking",
  READING_WRITING: "reading-writing",
};

export const ASSESSMENT_CYCLE_PURPOSE = {
  ADMISSION: "admission",
  SUMMATIVE: "summative",
  SCREENER: "screener",
};

export const ASSESSMENT_CYCLE_DATE_TYPE = {
  INDIVIDUAL: "individual",
  RANGE: "range",
};

export const ASSESSMENT_CYCLE_PHASE = {
  PREPARE: "prepare",
  CONDUCT: "conduct",
  STANDARDIZE: "standardize",
  EVALUATE: "evaluate",
  COMMUNICATE: "communicate",
  INSIGHTS: "insights",
};

export const GRADE = {
  THREE_TO_FOUR: "3-4",
  FIVE_TO_SIX: "5-6",
  SEVEN_TO_EIGHT: "7-8",
  NINE_TO_TEN: "9-10",
  ELEVEN_TO_TWELVE: "11-12",
};
export const DATE_TYPE = {
  INDIVIDUAL: "individual",
  RANGE: "range",
};

export const studentStatus = {
  ACTIVE_SUPPORT: "active-support",
  INACTIVE_SUPPORT: "inactive-support",
  ADMISSION_PENDING: "admission-pending",
  ARCHIVE: "archive",
};

export const studentSupportLevel = {
  HIGH: "high",
  MEDIUM: "medium",
  LOW: "low",
  MONITOR: "monitor",
  NONE: "none",
};

export const distributeOptions = {
  EQUALLY: "equally",
  MANUALLY: "manually",
};
export const standardizeStatus = {
  PENDING: "pending",
  COMPLETED: "completed",
};
export const ADMISSION_ASSESSMENT_STATUS = {
  READY: "ready",
  IN_PROGRESS: "in-progress",
  COMPLETED: "completed",
};
// A quick assessment is a CYCLE one when a cycle is attached to it — a student
// transferred out of an assessment cycle, or one an admin set up by hand for an
// enrolled student. ADMISSION is a walk-in candidate who is not enrolled yet.
export const QUICK_ASSESSMENT_TYPE = {
  CYCLE: "cycle",
  ADMISSION: "admission",
};
export const QUESTION_SET_STAGE = {
  PIONEER: "pioneer",
  EXPLORER: "explorer",
  PATH_FINDER: "pathFinder",
  FORERUNNER: "forerunner",
  COMPASS_NAVIGATOR: "compassNavigator",
  TRAILBLAZER: "trailblazer",
  FLUENT_VOYAGER: "fluentVoyager",
};

export const STAGE_VALUE = {
  [QUESTION_SET_STAGE.PIONEER]: 1,
  [QUESTION_SET_STAGE.EXPLORER]: 2,
  [QUESTION_SET_STAGE.PATH_FINDER]: 3,
  [QUESTION_SET_STAGE.FORERUNNER]: 4,
  [QUESTION_SET_STAGE.COMPASS_NAVIGATOR]: 5,
  [QUESTION_SET_STAGE.TRAILBLAZER]: 6,
  [QUESTION_SET_STAGE.FLUENT_VOYAGER]: 7,
};
export const ADMISSION_STATUS = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
};

export const ACCOMMODATION_TYPE = {
  TIME_EXTENSION: "time_extension",
  READ_INSTRUCTIONS: "read_instructions",
  READ_QUESTIONS: "read_questions",
  HANDWRITTEN_ANSWER: "handwritten_answer",
  ASSISTANCE: "assistance",
  SMALL_GROUP: "small_group",
  SCRIBE: "scribe",
};

export const TIME_EXTENSION_TYPE = {
  NONE: "none",
  FIVE_MINUTES: "5-minutes",
  TEN_MINUTES: "10-minutes",
  TWENTY_MINUTES: "20-minutes",
  INFINITE: "infinite",
};
export const TEST_SESSION_STATUS = {
  PENDING: "pending",
  STARTED: "started",
  PAUSED: "paused",
  COMPLETED: "completed",
  MARKED: "marked",
};

export const QUESTION_CRITERIA = {
  // Interpretive (Reading & Listening)
  I1: "i1",
  I2: "i2",
  I3: "i3",
  I4: "i4",
  I5: "i5",

  // Productive (Writing & Speaking)
  P1: "p1",
  P2: "p2",
  P3: "p3",
  P4: "p4",
  P5: "p5",
};

export const INTERPRETIVE_CRITERIA = [
  QUESTION_CRITERIA.I1,
  QUESTION_CRITERIA.I2,
  QUESTION_CRITERIA.I3,
  QUESTION_CRITERIA.I4,
  QUESTION_CRITERIA.I5,
];

export const PRODUCTIVE_CRITERIA = [
  QUESTION_CRITERIA.P1,
  QUESTION_CRITERIA.P2,
  QUESTION_CRITERIA.P3,
  QUESTION_CRITERIA.P4,
  QUESTION_CRITERIA.P5,
];

/** Criteria keys per test domain (i* → listening/reading, p* → speaking/writing). */
export const DOMAIN_CRITERIA_KEYS = {
  [QUESTION_SET_DOMAIN.LISTENING]: INTERPRETIVE_CRITERIA,
  [QUESTION_SET_DOMAIN.READING]: INTERPRETIVE_CRITERIA,
  [QUESTION_SET_DOMAIN.SPEAKING]: PRODUCTIVE_CRITERIA,
  [QUESTION_SET_DOMAIN.WRITING]: PRODUCTIVE_CRITERIA,
};

export const QUESTION_CRITERIA_FULL = {
  // Interpretive
  [QUESTION_CRITERIA.I1]: "Vocabulary Range & Recognition",
  [QUESTION_CRITERIA.I2]: "Comprehension of Main Ideas",
  [QUESTION_CRITERIA.I3]: "Understanding of Details",
  [QUESTION_CRITERIA.I4]: "Interpretation & Inference",
  [QUESTION_CRITERIA.I5]: "Language Analysis",

  // Productive
  [QUESTION_CRITERIA.P1]: "Vocabulary & Word Choice",
  [QUESTION_CRITERIA.P2]: "Complexity & Cohesion",
  [QUESTION_CRITERIA.P3]: "Grammar & Language Usage",
  [QUESTION_CRITERIA.P4]: "Comprehensibility",
  [QUESTION_CRITERIA.P5]: "Content",
};
export const QUESTION_CRITERIA_OPTIONS_WS = {
  [QUESTION_CRITERIA.P1]: "Vocabulary & Word Choice",
  [QUESTION_CRITERIA.P2]: "Cohesion & Complexity",
  [QUESTION_CRITERIA.P3]: "Grammar & Language Usage",
  [QUESTION_CRITERIA.P4]: "Comprehensibility",
  [QUESTION_CRITERIA.P5]: "Content",
};
export const READING_WRITING = "reading-writing";
export const LISTENING_SPEAKING = "listening-speaking";
export const FC_REPORT = "fc-report";
export const INSIGHTS = "insights";
export const COMPASS = "compass";
export const ADMISSION = "admission";
export const CYCLE_TRACKER = "cycle-tracker";
export const DATA_REVIEW = "data-review";
export const LANGUAGE_PROFILE = "language-profile";
export const AI_EVALUATION = "ai-evaluation";

export const SUBS_MODULES = {
  [READING_WRITING]: "Reading & Writing Assessment",
  [LISTENING_SPEAKING]: "Speaking & Listening Assessments",
  [FC_REPORT]: "FC Reports with Educator, Student, and Family perspectives",
  [INSIGHTS]: "Grade-level, Campus-level, and School-level insights",
  [COMPASS]:
    "Compass next steps in language learning at student, class, grade, campus, and school levels",
  [ADMISSION]: "Admissions Assessments suite",
  [CYCLE_TRACKER]:
    "Assessment Cycle Tracker to organize, conduct, and standardize group assessment sessions",
  [DATA_REVIEW]:
    "Data Review module for teams to review and support language growth",
  [LANGUAGE_PROFILE]: "Student Voice & Language Profiles for all students",
  [AI_EVALUATION]: "AI-assisted Evaluations for Writing and Speaking",
};
